import { useDataStore } from "@/stores";
import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent } from "@mui/material";

type DownloadVersionDropdownProps = {
    value: string[];
    onChange: (event: SelectChangeEvent<string[]>) => void;
};

const DownloadVersionsDropdown = ({ value, onChange }: DownloadVersionDropdownProps) => {
    const versions = useDataStore((state) => state.versions);

    return (
        <FormControl fullWidth size={"medium"} id={"medium"}>
            <InputLabel id="version-dropdown-label">Version(s)</InputLabel>
            <Select
                labelId="version-dropdown-label"
                id="version-dropdown"
                value={value}
                onChange={onChange}
                input={<OutlinedInput label={"Version(s)"} />}
                MenuProps={{
                    PaperProps: {
                        style: {
                            maxHeight: 48 * 4.5 + 8,
                        },
                    },
                }}
                fullWidth
                multiple
            >
                {versions
                    .sort((a, b) => b.publicationDate.getTime() - a.publicationDate.getTime())
                    .map((x) => (
                        <MenuItem key={x.name} value={x.name}>
                            {x.name}
                        </MenuItem>
                    ))}
            </Select>
        </FormControl>
    );
};

export default DownloadVersionsDropdown;
